import FormInput from "@standard/components/FormInput/FormInput";
import TableForm from "@standard/components/TableForm";

const DocumentTable = ({ values, onChange, onFileChange, disabled }) => {
  const fields = [
    {
      name: "name",
      label: "Name",
      type: disabled ? "label" : "textbox",
      required: true,
    },
    {
      name: "assets",
      label: "Example",
      type: "custom",
      control: (item, itemIndex) => {
        return (
          <div>
            {item.values.assetsPreview &&
              item.values.assetsPreview.length > 0 && (
                <div className="mt-3">
                  <FormInput
                    field={{
                      name: "assetsPreview",
                      type: "filePreview",
                      disabled: disabled,
                    }}
                    value={item.values.assetsPreview}
                    onChange={(d) => {
                      onFileChange(itemIndex, d);
                    }}
                  ></FormInput>
                </div>
              )}
            <FormInput
              field={{
                name: "assets",
                type: "file",
                multiple: true,
                disabled: disabled,
              }}
              onChange={(d) => {
                onFileChange(itemIndex, d);
              }}
            ></FormInput>
          </div>
        );
      },
    },
  ];

  return (
    <div className="col-12">
      <TableForm
        label="Documents"
        fields={fields}
        values={values}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

export default DocumentTable;
